import React, { Component } from 'react';
import MainPageCompenent from './MainPageCompenent';
import MainContent from './MainContent';
import PrivateRoute from './PrivateRoute';

class Dashboard extends Component {
    constructor(props) {
        super(props);

    }

    render() {
        return (
            <PrivateRoute>
                <MainPageCompenent>
                    <MainContent />
                </MainPageCompenent>
            </PrivateRoute>
        );
    }
}

export default Dashboard;